import { Snowflake } from "lucide-react";

const ITEMS = [
  "$SOLMAS",
  "HO HO HODL",
  "COMMUNITY TAKEOVER",
  "SLEIGH TO DEC 25 2026",
  "MERRY SOLMAS",
  "NORTH POLE ARMY",
  "CTO'D BY THE COMMUNITY",
];

function Row({ hidden }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((t, i) => (
        <span
          key={`${t}-${i}`}
          className="mx-6 flex items-center gap-6 whitespace-nowrap font-display text-lg font-extrabold uppercase tracking-wide sm:text-2xl"
        >
          <span
            className={
              i % 2
                ? "text-slate-100"
                : "bg-gradient-to-r from-[#FF2B4A] to-[#00F5D4] bg-clip-text text-transparent"
            }
          >
            {t}
          </span>
          <Snowflake className="h-5 w-5 text-[#00F5D4]/60" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-gradient-to-r from-[#FF2B4A]/10 via-[#0F141C] to-[#00F5D4]/10 py-4"
    >
      <div className="animate-marquee-x flex w-max">
        <Row hidden={false} />
        <Row hidden />
      </div>
    </div>
  );
}
